window.theEndCalled = 0;

function theEnd() {
  if (window.inPreviewMode) {
    // nothing to do for the end here
    return;
  }
    if (!window.areAllMicUploadsDone() && window.onBeforeEndCallback) {
        showMicUploadProgressBar();
        window.onBeforeEndCallback(theEnd);
        return;
    }

    if (!window.areAllMicUploadsDone() && window.callbackAfterMicUpload) {
        return;
    }

    if(window.theEndCalled) {
        return;
    }

    window.stopAudioOnNewTrial = true;
    window.stopBackgroundAudio();

    hideAll();
    cleanTimers();
    window.theEndCalled = 1;

    if (window.enable_email_catching) {
        try {
            document.cookie = "MCPopupClosed=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
           	// mailchimpLoader.start({"baseUrl":"mc.us16.list-manage.com","uuid":"7bd6b36aae347e02cf58a9e94","lid":"d261da9989"});
           	// if(document.cookie.indexOf('testable_minds_session') < 0){
	        //     $("#mindsInviteModal").animate({right: '0px'});
	        //     $(document).on('click', ".close", function(){
	        //     	$("#mindsInviteModal").animate({right: '-550px'});
	        //     });
	        // }
       } catch(e) {}
    }

    contentText = debrief_text;

    if (debrief_text === "") {
        contentText = textScreens['end'][language][1];
    }

    avgScoreText = debrief_average_text; // textScreens['end'][language][2];
    if (avgScoreText == "Average correct score: ") {
        avgScoreText = textScreens['end'][language][2];
    }

    codeText = debrief_code_text; // textScreens['end'][language][3];
    if (codeText == "The confirmation code for completing this experiment is: ") {
        codeText = textScreens['end'][language][3];
    }


    randomCode = randomString(16, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
    correctValues = correct.slice(1, correct.length); //get rid of first element with label, keep only the values
    for(var i in correctValues){
        if(correctValues[i] == ""){
            correctValues[i] = 0;
        }
    }
    avgCorrect = mean(correctValues); // function to compute average

    if (trialRow && window.hasCorrectSelect) {
        correctSelectValues = correctSelect.slice(1, correctSelect.length); //get rid of first element with label, keep only the values
        avgCorrectSelect = mean(correctSelectValues); // function to compute average for select trials
        avgCorrect = avgCorrectSelect;
    }


    titleText = "";
    //display score if indicated
    if (display_score == "on") {
        titleText = avgScoreText + Math.round(avgCorrect * 100) + "%";
    }

    //start randomCode with j14 if correct above threshold (90%)
    if (avgCorrect > .8) { randomCode = "j14" + randomCode; }

    //add randomCodeText and randomCode to the content if selected
    if (generate_code == "on") {
        if (debrief_is_random_code == 0) { 
            randomCode = debrief_code; 
        }
        
        if (debrief_is_random_code && window.userVars && window.userVars['completionCode']) {
            randomCode = window.userVars['completionCode'];
        }

        contentText += "<br><br>" + codeText + "<br> <strong style='font-size: x-large'>" + randomCode + "</strong>";
        saveInfo.push(randomCode);
        saveInfoColumns.push('completionCode');
    }

    if (show_visuals == 1) {
        var url_debrief = url.replace("start", "visualization");
        contentText += '<br><br>To see your results, <a target="_blank" href="' + url_debrief + '"><b><font color="blue">CLICK HERE</font></b></a>';
    }

    if (debrief_show_link == 1) {
        const showUrl = addCurrentQueryParamsToUrl(replaceQueryParamsPlaceholders(replaceVariables(debrief_link_url)));
        if (debrief_link_text == '') debrief_link_text = showUrl;
        contentText += '<br><br>' + debrief_link_textarea + ' <a target="_blank" href="' + showUrl + '"><b><font color="blue">' + debrief_link_text + '</font></b></a>';
        if (debrief_link_url && debrief_auto_redirect) {
            handleCustomLinkRedirect(showUrl);
        }
    }

    //for christina pressl only
    if (experimentName == "498339") {
        url_pressl = 'http://faceweb.me/cfmt-result-interpretation-guide';
        contentText += '<br><br>To learn more about what your result means, <a target="_blank" href="' + url_pressl + '"><b><font color="blue">CLICK HERE</font></b></a>';
    }

    //camelot research project
    // do not remove it may be needed in the future
    // try {
        // var psid = getParameterByName('psid');
        // if (psid) {
        //     url_pressl = 'https://dkr1.ssisurveys.com/projects/end?rst=1&psid=' + psid + '&basic=65729';
        //     contentText += '<br><br><h3>To finish <a target="_blank" href="' + url_pressl + '"><b><font color="blue">CLICK HERE TO COMPLETE</font></b></a>&nbsp;this survey. <br><small>otherwise, your participation won\'t be recorded</small></h3>';        }

   // } catch(err) {}

    displayText("title", titleText);
    displayText("content", contentText, 'experiment-debrief');

    window.logExperimentEvent(window.consortEvents.FINISHED);

    // results[0]=saveInfo; !!! MAKE SURE YOU SAVE ADDED VARIABLES AND ONLY VARIABLES FROM THE STIMFILE!!!!
    // results[0]=saveFormat;

    Bugsnag && Bugsnag.leaveBreadcrumb('Reached end of experiment. Generating results.');

    counterResults = 0;
    for (var iCol = 0; iCol < allColumns.length; iCol++) {
        // save only columns defined in the csv file
        if (definedColumns[iCol] == 1) {
            // results[counterResults] = saveArrays[iCol];
            results[csvValidColumns.indexOf(allColumns[iCol])] = saveArrays[iCol];
            counterResults = counterResults + 1;
        }
    }

    for (var iCol = 0; iCol < csvNewColumns.length; iCol++)
    {
        results[iCol+counterResults] = saveUnusedArrays[iCol];
    }


    // save real stim pos
    if (resultsArrayNotEmpty(stimPos_actual)) {

        for (var i = stimPos_actual.length - 1; i >= 1; i--) {
            if (Array.isArray(stimPos_actual[i])) {
                stimPos_actual[i] = stimPos_actual[i].map(function (pos) {if(!pos) return ''; return pos.horizontal + ' ' + pos.vertical; }).join(';');
                if (!stimPos_actual[i]) {
                    stimPos_actual[i] = 'na';
                }
            }
        }

        results.push(stimPos_actual);
    }

    // save real iti
    if(resultsArrayNotEmpty(ITI_ms)) {
        results.push(ITI_ms);
        results.push(ITI_f);
        results.push(ITI_fDuration);
    }


    if (resultsArrayNotEmpty(presTime_ms)) {

        for (var i = presTime_ms.length - 1; i >= 1; i--) {
            if (Array.isArray(presTime_ms[i])) {
                presTime_ms[i] = presTime_ms[i].join(';');
                if (!presTime_ms[i]) {
                    presTime_ms[i] = 'na';
                }
            }
        }

        results.push(presTime_ms);
        results.push(presTime_f);
        results.push(presTime_fDuration);
    }

    if (resultsArrayNotEmpty(ISI_ms)) {

        for (var i = 0; i < ISI_ms.length; i++) {
            if (Array.isArray(ISI_ms[i])) {
                ISI_ms[i] = ISI_ms[i].join(';');
                if (!ISI_ms[i]) {
                    ISI_ms[i] = 'na';
                }
            }
        }

        results.push(ISI_ms);
        results.push(ISI_f);
        results.push(ISI_fDuration);
    }

    if (resultsArrayNotEmpty(stimActual)) {
        results.push(stimActual);
    }

    if(resultsArrayNotEmpty(window.tallies)) {
        results.push(window.tallies);
    }

    if (!isEmptyObject(window.customVariables)) {
        addCustomVariablesToResults(window.results, window.customVariables, window.results[0].length - 1);
    }

    if(resultsArrayNotEmpty(window.scores)) {
        results.push(window.scores);
    }

    if (resultsArrayNotEmpty(window.responseRowsActual)) {
        results.push(window.responseRowsActual);
    }

    // for all window.actualValues object keys
    // generates <column_name>_actual columns with values for result file
    for (var key in window.actualValues) {
        if (window.actualValues.hasOwnProperty(key)) {
            if (resultsArrayNotEmpty(window.actualValues[key])) {
                results.push(window.actualValues[key]);
            }
        }
    }

    if(Object.keys(window.scoresObject).length !== 0) {
        saveInfoColumns.push('score');
        saveInfo.push(window.getTotalScore());
    }

    const talliesString = window.getTalliesString();
    if (talliesString && talliesString.length > 0) {
        saveInfoColumns.push('tallies');
        saveInfo.push(talliesString);
    }

    if (window.record_framerate == "on") {
        window.fpsMean = mean(listFrameRates);
        window.fpsSD = standardDeviation(listFrameRates);
        saveInfoColumns.push('fps_start', 'fps_M', 'fps_SD');
        saveInfo.push(window.fpsStart, window.fpsMean.toFixed(2), window.fpsSD.toFixed(2));
    }

    saveInfoColumns.push('duration_s');
    const durationSeconds = (timestamps[timestamps.length - 1] + RTs[RTs.length - 1]) / 1000;
    saveInfo.push(durationSeconds);


    results.push(timestamps);
    results.push(responses);
    if (resultsArrayNotEmpty(window.responseTextValues)) {
        results.push(window.responseTextValues);
    }
    results.push(RTs);

    results.push(stimOrder_actual);

    if (resultsArrayNotEmpty(RTkeys)) { results.push(RTkeys); }

    if(columnIsDefined("key")){
        results.push(correct);
    }
    if (responseCodes.length > 1) {
        results.push(responseCodes);
    }

    // remove undefined columns
    var newResults = [];
    for (var i = 0; i < results.length; i++) {
        if (typeof results[i] !== 'undefined') {
            newResults.push(JSON.parse(JSON.stringify(results[i])));
        }
    };
    results = JSON.parse(JSON.stringify(newResults));
    // add rowNo as the first element (will result as the first column in result CSV)
    results.unshift(rowNo);

    // staircases
    if (Object.keys(staircaseResults).length > 0) {
    	// we have staircase results
    	// inefficient way to find these
    	// for some reasons, indexes in staircaseResults is not populated correctly, maybe will fix some day. Till then, this works fine to find and mark the end trial for each staircase
    	var staircaseIndex = findStaircaseIndexInResults(results);
    	if (staircaseIndex > 0) {
    		var staircasesEndindexes = findEndStaircases(results[staircaseIndex]);
    		var staircasesEndResults = buildStaircaseEndResults(staircasesEndindexes, results[staircaseIndex].length);
    		results.push(staircasesEndResults);
    	}
	}

    results = removeNA(results);

    resultsTransposed = transpose(results);

    csvContentServer = convertServerContentToCsv(saveInfoColumns, saveInfo, resultsTransposed);

    download();

    //trigger end of trial
    testableTriggerEvent(window.events.experimentCompleted, null);

    //disable sending beacon when leaving experiment since it is now completed
    window.removeEventListener("unload", leaveBeforeEnd);
    console.log('removeEventListener unload');
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}


function findEndStaircases(staircases) {
	var staircaseEndsIndexes = {};
	var endIndexes = {};
	for (var i = 1; i < staircases.length; i++) {
		if (staircases[i] != 'na') {
			var staircaseId = staircases[i].substring(0 , staircases[i].indexOf(":")) || staircases[i];
			staircaseEndsIndexes[staircaseId] = i;
		}
	}

	for(var key in staircaseEndsIndexes){
		endIndexes[staircaseEndsIndexes[key]] = true;
	}

	return endIndexes;
}

function buildStaircaseEndResults(staircaseEndsIndexes, trialsCount) {
	var staircasesEnds = ['staircaseResult'];

	for (var i = 1; i < trialsCount; i++) {
		staircasesEnds.push(staircaseEndsIndexes[i] ? 1 : 'na' );
	}

	return staircasesEnds;
}

function findStaircaseIndexInResults(results) {
	for (var i = 0; i < results.length; i++) {
		if (results[i][0] == 'staircase') {
			return i;
		}
	}

	return -1;
}


function addCustomVariablesToResults(results, customVariables, rowsCount) {

    for (const variableName in customVariables) {
        const variableArray = new Array(rowsCount + 1);
        variableArray[0] = variableName;
        for (const trialIndex in customVariables[variableName]) {
            variableArray[trialIndex] = customVariables[variableName][trialIndex];
        }
        results.push(variableArray);
    }

    
}